import publisher_routes from './publisher_routes';
import auth_routes from './auth';
import admin_routes from './admin_routes';
// import member_routes from "./member";
// import developer_routes from "./developer";

// Define types
export type RouteGroup = {
  [path: string]: React.ComponentType;
};

export type RouteConfig = {
  prefix: string;
  routes: RouteGroup;
};

// Actual route config
const routes: RouteConfig[] = [
  
  {
    prefix: '',
    routes: auth_routes,
  },
  {
    prefix: '/publisher',
    routes: publisher_routes,
  },
  {
    prefix: '/admin',
    routes: admin_routes,
  },
];

export default routes;
